import { render } from "./AuthenticationCard.vue?vue&type=template&id=7c422a9e"
import script from "./AuthenticationCard.vue?vue&type=script&lang=js"
export * from "./AuthenticationCard.vue?vue&type=script&lang=js"
script.render = render

export default script